// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { SubscriptionRoutes } from ".";
import { PageRoute } from "..";
import { ThemeProvider } from "@emotion/react";
import { Elements, RecurlyProvider } from "@recurly/react-recurly";
import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { noop } from "lodash";
import { Component, ReactNode } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, Switch } from "react-router-dom";
import { Dispatch } from "redux";

import Redirect from "components/Redirect";
import { config } from "config/config";
import { Cookie } from "constants/cookies";
import { QueryKeys } from "constants/query-keys";
import { Right } from "constants/right";
import Role from "constants/role";
import { customFieldsUtm } from "constants/searchParams";
import { getCookie } from "helpers/cookies";
import { buildPlanCode, getNewSubscriptionDefaultState, isExpired } from "helpers/subscription";
import { IStoreState } from "interfaces/storeState";
import { withRememberLastRoute } from "routes/withRememberLastRoute";
import { getNonViewersCount, selectLoggedInAgentPermission } from "store/entities/agents";
import { getBilling } from "store/entities/billing";
import { selectShopifyIntegration } from "store/entities/integrations";
import { selectManagedByPartner, selectManagedByPartnerEmail } from "store/entities/license";
import { IMacro } from "store/entities/macros/interfaces";
import { RecurlyActions } from "store/entities/recurly";
import { getShouldFetchActiveCoupon, selectRecurlyCoupon } from "store/entities/recurly/selectors";
import { BillingCycle, ISubscription, Plan, selectCurrentSubscription } from "store/entities/subscriptions";
import { hasRight } from "store/features/session";
import { SubscriptionViewActions, selectFocusedColumn } from "store/views/subscription";
import { legacyTheme } from "themes/legacyTheme";

import AccountDetailsContainer from "./AccountDetails/AccountDetailsContainer";
import PartnerSubscription from "./PartnerSubscription";
import ShopifySubscription from "./ShopifySubscription";
import SubscriptionCancel from "./SubscriptionCancel/SubscriptionCancel";
import SubscriptionCardContainer from "./SubscriptionCard/SubscriptionCardContainer";
import { SubscriptionExpired } from "./SubscriptionExpired/SubscriptionExpired";
import { SubscriptionInvoicesContainer } from "./SubscriptionInvoices/SubscriptionInvoicesContainer";
import { SubscriptionLayout } from "./SubscriptionLayout";
import { SubscriptionNoAccess } from "./SubscriptionNoAccess/SubscriptionNoAccess";
import { SubscriptionPlans } from "./SubscriptionPlans";
import { ThankYouPage } from "./thank-you-page/ThankYouPage";
import { withRecurlyJs } from "./withRecurlyJs";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: IStoreState) => ({
  nonViewersCount: getNonViewersCount(state),
  subscription: selectCurrentSubscription(state),
  canManageSubscription: hasRight(state, Right.ManageSubscription),
  loggedInAgentPermission: selectLoggedInAgentPermission(state),
  focusedColumn: selectFocusedColumn(state),
  coupon: selectRecurlyCoupon(state),
  shopifyIntegration: selectShopifyIntegration(state),
  isManagedByPartner: selectManagedByPartner(state),
  partnersContactEmail: selectManagedByPartnerEmail(state),
  shouldFetchCoupon: getShouldFetchActiveCoupon(state),
  billing: getBilling(state),
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch) => ({
  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(2345)
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCoupons: (planCode: string, agents: number) => dispatch(RecurlyActions.fetchCoupon({ planCode, agents })),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  checkCoupon: (planCode: string, agents: number, couponName: string) =>
    // @ts-expect-error TS(2345)
    dispatch(RecurlyActions.checkRecurlyCoupon({ planCode, agents, couponName })),
  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(2345)
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onSetFocusedColumn: (focusedColumn: number) => dispatch(SubscriptionViewActions.setFocusedColumn(focusedColumn)),
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
interface IRouteComponentProps extends RouteComponentProps {
  location: {
    pathname: string;
    search: string;
    hash: string;
    state: {
      fromCustomFields: boolean;
    };
  };
}

interface IProps extends StateProps, DispatchProps, IRouteComponentProps {
  queryClient: QueryClient;
}

interface IState {
  newSubscription: ISubscription;
  macros: IMacro[];
}

class Router extends Component<IProps, IState> {
  static defaultProps = {
    canManageSubscription: false,
    shouldFetchCoupon: false,
    billing: null,
    subscription: null,
    coupon: null,
    shopifyIntegration: null,
    isManagedByPartner: false,
    partnersContactEmail: "",
    nonViewersCount: 0,
    focusedColumn: 0,
    loggedInAgentPermission: Role.Normal,
    onSetFocusedColumn: noop,
    fetchCoupons: noop,
    checkCoupon: noop,
  };

  state = {
    macros: [],
    newSubscription: getNewSubscriptionDefaultState(
      this.props.subscription
        ? {
            ...this.props.subscription,
            plan: this.props.subscription.plan,
          }
        : null,
      this.props.billing,
      this.props.nonViewersCount
    ),
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    const { subscription, billing, nonViewersCount, queryClient } = this.props;
    const macros = queryClient.getQueryData<IMacro[]>([QueryKeys.Macros]);
    this.setState({ macros: macros || [] });

    this.fetchCoupons();
    if (window.location.search.endsWith(customFieldsUtm)) {
      this.setState({
        newSubscription: getNewSubscriptionDefaultState(
          subscription
            ? {
                ...subscription,
                plan: Plan.Enterprise,
              }
            : null,
          billing,
          nonViewersCount
        ),
      });
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidUpdate(prevProps: IProps, prevState: IState) {
    const { subscription, billing, nonViewersCount } = this.props;
    if (prevProps.subscription !== subscription || prevProps.billing !== billing) {
      this.setState({
        newSubscription: getNewSubscriptionDefaultState(
          subscription
            ? {
                ...subscription,
                plan: this.props.subscription.plan,
              }
            : null,
          billing,
          nonViewersCount
        ),
      });

      this.fetchCoupons();
    }

    if (
      prevState.newSubscription.billingCycle !== this.state.newSubscription.billingCycle ||
      prevState.newSubscription.plan !== this.state.newSubscription.plan
    ) {
      const coupon = getCookie(Cookie.CouponCode);

      if (!coupon) {
        return;
      }

      this.props.checkCoupon(
        buildPlanCode(this.state.newSubscription.plan, this.state.newSubscription.billingCycle),
        this.state.newSubscription.agents,
        coupon
      );
    }
  }

  fetchCoupons = (): void => {
    const { fetchCoupons, canManageSubscription, shouldFetchCoupon } = this.props;

    if (canManageSubscription && shouldFetchCoupon) {
      fetchCoupons(
        buildPlanCode(this.state.newSubscription.plan, this.state.newSubscription.billingCycle),
        this.state.newSubscription.agents
      );
    }
  };

  handlePlanChange = (plan: Plan): void => {
    const { subscription } = this.props;
    if (subscription.plan !== Plan.Enterprise) {
      this.setState(prevState => ({
        newSubscription: {
          ...prevState.newSubscription,
          plan,
        },
      }));
    }
  };

  handleBillingCycleChange = (billingCycle: BillingCycle): void => {
    this.setState(prevState => ({
      newSubscription: {
        ...prevState.newSubscription,
        billingCycle,
      },
    }));
  };

  handleSeatsChange = (agents: number): void => {
    this.setState(prevState => ({
      newSubscription: {
        ...prevState.newSubscription,
        agents,
      },
    }));
  };

  render(): ReactNode {
    const {
      subscription,
      billing,
      coupon,
      nonViewersCount,
      canManageSubscription,
      loggedInAgentPermission,
      focusedColumn,
      onSetFocusedColumn,
      shopifyIntegration,
      isManagedByPartner,
      partnersContactEmail,
    } = this.props;

    const { newSubscription, macros } = this.state;
    const subscriptionExpired = isExpired(subscription);
    const invoiceEmail = billing ? billing.invoiceEmails[0] : "";
    const spareAgents = subscription ? Math.max(0, subscription.agents - nonViewersCount) : 0;
    const isExternalBilling = shopifyIntegration && shopifyIntegration.settings?.billingUrl && !isManagedByPartner;

    if (subscriptionExpired && !canManageSubscription) {
      return <SubscriptionExpired />;
    }

    if (loggedInAgentPermission && loggedInAgentPermission !== Role.Owner) {
      return <SubscriptionNoAccess permission={loggedInAgentPermission} />;
    }

    return (
      <RecurlyProvider publicKey={config.recurlyPublicKey} required={["cvv", "postal_code", "country"]}>
        <Elements>
          <ThemeProvider theme={legacyTheme}>
            <Switch>
              <PageRoute
                exact
                path={SubscriptionRoutes.Shopify}
                documentTitle="Your subscription"
                render={() => <ShopifySubscription shopifyIntegration={shopifyIntegration} />}
              />
              <PageRoute
                exact
                path={SubscriptionRoutes.Partner}
                documentTitle="Your subscription"
                render={() => <PartnerSubscription partnersContactEmail={partnersContactEmail} />}
              />
              {isExternalBilling && <Redirect to={SubscriptionRoutes.Shopify} />}
              {isManagedByPartner && <Redirect to={SubscriptionRoutes.Partner} />}
              <PageRoute
                exact
                path={SubscriptionRoutes.Plans}
                documentTitle="Your subscription"
                render={() => (
                  <SubscriptionLayout
                    containerTitle="Your subscription"
                    subscriptionExpired={subscriptionExpired}
                    focusedColumn={focusedColumn}
                    onSetFocusedColumn={onSetFocusedColumn}
                    content={
                      <SubscriptionPlans
                        macros={macros}
                        subscription={subscription}
                        newSubscription={newSubscription}
                        billing={billing}
                        nonViewersCount={nonViewersCount}
                        onPlanChange={this.handlePlanChange}
                        onBillingCycleChange={this.handleBillingCycleChange}
                        onSeatsChange={this.handleSeatsChange}
                      />
                    }
                  />
                )}
              />
              <PageRoute
                exact
                path={SubscriptionRoutes.Card}
                documentTitle="Credit card"
                render={() => <SubscriptionCardContainer newSubscription={newSubscription} />}
              />
              {!subscriptionExpired && (
                <PageRoute
                  exact
                  path={SubscriptionRoutes.ThankYou}
                  documentTitle="Thank you!"
                  render={() => (
                    <ThankYouPage
                      invoiceEmail={invoiceEmail}
                      subscription={newSubscription}
                      coupon={coupon}
                      spareAgents={spareAgents}
                    />
                  )}
                />
              )}
              <PageRoute
                exact
                path={SubscriptionRoutes.CancelAccount}
                documentTitle="Cancel account"
                component={SubscriptionCancel}
              />
              <PageRoute
                exact
                path={SubscriptionRoutes.AccountDetails}
                documentTitle="Account details"
                render={() => (
                  <SubscriptionLayout
                    containerTitle="Account details"
                    focusedColumn={focusedColumn}
                    onSetFocusedColumn={onSetFocusedColumn}
                    content={<AccountDetailsContainer subscription={subscription} />}
                  />
                )}
              />
              <PageRoute
                exact
                path={SubscriptionRoutes.Invoices}
                documentTitle="Invoices"
                render={() => (
                  <SubscriptionLayout
                    containerTitle="Invoices"
                    focusedColumn={focusedColumn}
                    onSetFocusedColumn={onSetFocusedColumn}
                    smallPadding
                    content={<SubscriptionInvoicesContainer invoiceEmail={invoiceEmail} />}
                  />
                )}
              />
              <Redirect to={SubscriptionRoutes.Plans} />
            </Switch>
          </ThemeProvider>
        </Elements>
      </RecurlyProvider>
    );
  }
}

function withQueryClient<P>(WrappedComponent: React.ComponentType<P & { queryClient: QueryClient }>) {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  return function QueryClientInjector(props: P) {
    const queryClient = useQueryClient();
    return <WrappedComponent {...props} queryClient={queryClient} />;
  };
}

export default withQueryClient(
  withRememberLastRoute(withRecurlyJs(connect(mapStateToProps, mapDispatchToProps)(Router)), "/subscription")
);
